import { Injectable } from '@angular/core';
import { APP_CONFIG, NameConfig } from 'app.config';
import { AppState } from 'app/shared/common/utils/AppState';
import { HttpHelper } from 'app/shared/common/utils/http/HttpHelper';
import { AgGridWithoutCacheService } from 'app/shared/components/base/ag-grid-without-cache/ag-grid-without-cache.service';
import { Observable, catchError, map, throwError } from 'rxjs';

@Injectable()
export class TenantService extends AgGridWithoutCacheService {
  private _baseUrl = APP_CONFIG.MCR_XPSECMT + 'tenant';
  constructor(
    private _httpHelper: HttpHelper,
    public _appState: AppState
  ) {
    super(_httpHelper, _appState)
  }

  public getList(url?: string, payload?: any): Observable<any> {
    url = url || this._baseUrl + '/pivotPaging';
    payload = {
      startRow: 0,
      endRow: 30,
      filterModel: {},
      sortModel: [],
      ...(payload || {})
    }
    return this._httpHelper?.methodPostObservableService(url, payload).pipe(
      catchError(err => {
        return throwError(() => new Error(`An error occurred: ${err.message}`));
      }),
      map(res => res?.data?.data),
    )
  }

  public getListTenantByApp(url?: string, payload?: any) {
    url = url || APP_CONFIG.MCR_XPSECMT + 'tenantApp/pivotPagingTenantByApp';
    payload = {
      startRow: 0,
      endRow: 30,
      filterModel: {},
      sortModel: [],
      ...(payload || {})
    }
    return this._httpHelper?.methodPostObservableService(url, payload).pipe(
      catchError(err => {
        return throwError(() => new Error(`An error occurred: ${err.message}`));
      }),
      map(res => res?.data?.data),
    )
  }

  public getTenantsOfSuperUsers(url?: string) {
    url = url || APP_CONFIG.MCR_XPSECMT + 'tenant/getTenantsOfSuperUsers';
    return this._httpHelper?.methodGetObservableService(url)?.pipe(
      catchError(err => {
        return throwError(() => new Error(`An error occurred: ${err.message}`));
      }),
      map(res => res?.data),
    )
  }

  public changeTenant(payload: any, url?: string): Promise<any> {
    url = url || NameConfig.HOST_NAME + 'api/auth/changeTenant';
    return this._httpHelper.methodPostService(url, payload);
  }

  public getListTenantByAppTotalItems(payload: any, url?: string) {
    url = url || APP_CONFIG.MCR_XPSECMT + 'tenantApp/pivotCountTenantByApp';
    payload = {
      startRow: 0,
      endRow: 30,
      filterModel: {},
      sortModel: [],
      ...(payload || {})
    };
    return this._httpHelper?.methodPostObservableService(url, payload)?.pipe(
      catchError(err => {
        return throwError(() => new Error(`An error occurred: ${err.message}`));
      }),
      map(res => res?.data),
    )
  }

  public getTotalItems(url?: string, payload?: any) {
    url = url || this._baseUrl + '/pivotCount';
    payload = {
      startRow: 0,
      endRow: 30,
      filterModel: {},
      sortModel: [],
      ...(payload || {})
    };
    return this._httpHelper?.methodPostObservableService(url, payload)?.pipe(
      catchError(err => {
        return throwError(() => new Error(`An error occurred: ${err.message}`));
      }),
      map(res => res?.data),
    )
  }
}
